module.exports = __webpack_public_path__ + "static/media/delta_logo.db24208f.svg";